// config
import { appConfig } from '../../config/app-config';

export const navigationConfig = {
    // load
    loadRequestMaxElements: 100,
    loadRequestErrorMsgTimeout: 5000,

    // request errors
    requestErrorDefaultUiMessage: 'Server Anfrage mit Fehler beendet',

    // display
    displayMaximumEdgeDepth: 999,
    displayDefaultEdgeGroup: 'all',

    // respond
    loadRespondDataRootIdentifier: 'root',
    loadRespondDataVirtualRootIdentifier: 'result',               // Achtung: bei Änderung in elementsResultInitial spiegeln
    loadRespondErrorIdentifier: 'code',

    // search result
    elementsResultInitial: {
        result: []                          // Achtung: Key muss identisch zu Wert von
    },                                     // loadRespondDataVirtualRootIdentifier sein
    defaultValuesForRoot: {
        id: 'Suchergebnis',
        bezeichnung: 'Suchergebnis',
        anmerkung: 'Suchergebnis'
    },

    // URL
    urlDocumentChecklist: '/api/v1/documents/checklist',
    urlDocumentManualChecklist: '/api/v1/documents/manualChecklist',
    urlDataInitialSearch: '/api/v1/data/graph',
    urlDataExtendedSearch: '/api/v1/data/graph',
    urlDataGetDetails: '/api/v1/data/collections',
    urlDataPostDetails: '/api/v1/data/collections',
    urlDataGetConfig: '/api/v1/data/clientConfig',
    urlDataRemoveEdge: '/api/v1/data/collections',
    urlDataPatch: '/api/v1/data',
    urlDataAddEdge: '/api/v1/data/collections',
    urlDataCollectionSchema: '/api/v1/data/collections/dbg_Schema',
    urlDataCollectionUiSchema: '/api/v1/data/collections/dbg_UIConfig',
    urlNewEdgeAndElement: '/api/v1/data/collections',
    urlSetDefaults: '/api/v1/data/collections',
    urlCheckers: '/api/v1/data/checker',
    urlValidation: '/api/v1/data/collections',

    // search History in Menü
    navSearchHistroyMaxEntries: 5,

    // steuerszenarium -> undefinierter schaltet ui value
    steuerungUndefSteuertEintrag: '-undef-',

    // debug
    debugMode: false,                   // wird in main.ts auf false gesetzt
    debugModeNavSearch: false,
    debugModeNavSearchParse: false,
};



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/nav/config/navigation.config.ts